/**
 * The Cmd/Ctrl-K binding, shared by the listener that opens global search and
 * the header buttons that advertise it — so the label can never drift from the
 * keys that actually work.
 */

const isMac = /Mac OS X|Macintosh|iPhone|iPad/.test(navigator.userAgent);

/** "⌘K" on Apple keyboards, "Ctrl K" everywhere else. */
export const SEARCH_HOTKEY_LABEL = isMac ? '⌘K' : 'Ctrl K';

/** For aria-label and title, where the glyphs read badly to a screen reader. */
export const SEARCH_HOTKEY_SPOKEN = isMac ? 'Command K' : 'Control K';

/**
 * Matches on `code` first: `key` is the *typed character*, so on a Cyrillic or
 * any other non-Latin layout Cmd-K arrives as `к` and a key-only check goes
 * dead. `key` stays as the fallback for layouts that remap physical keys
 * (Dvorak, Colemak), where the letter the user pressed is the one they mean.
 *
 * altKey is excluded because AltGr on Windows reports as Ctrl+Alt, which would
 * otherwise turn AltGr-K into a search shortcut mid-word.
 */
export const isSearchHotkey = (e: KeyboardEvent): boolean =>
  (e.metaKey || e.ctrlKey) &&
  !e.altKey &&
  !e.repeat &&
  (e.code === 'KeyK' || e.key.toLowerCase() === 'k');
